import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { useViewClaimDetails } from 'all-in-one-shared-api';

import { GenericResult, Spinner } from 'components';

import { SettleContent } from './SettleContent';

interface SettleOneProps {
  claimId: string;
  sequenceNo: number;
}

export const SettleOne = ({ claimId, sequenceNo }: SettleOneProps): JSX.Element => {
  const { t } = useTranslation();
  const { keycloak, initialized } = useKeycloak();
  const [inited, setInited] = useState(false);

  const isShortfall = true;

  const { shouldFetch, data, isLoading, error } = useViewClaimDetails(
    { name: 'useViewClaimDetails', params: { claimId: claimId || '', sequenceNo, isShortfall } },
    keycloak.token || '',
    claimId || '',
    sequenceNo,
    undefined,
    isShortfall,
  );

  useEffect(() => {
    shouldFetch(initialized && !!keycloak.authenticated && !!keycloak.token);
    console.log('触发几次');
    if (!inited) setInited(true);
  }, [inited, initialized, keycloak.authenticated, keycloak.token, shouldFetch]);

  useEffect(() => {
    console.log(error ? true : false, 11111111111111);
  }, [data, error]);
  if (!inited || isLoading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <GenericResult
        status="error"
        title={t('claims.notFound.title')}
        defaultTo="/claims/shortfall"
        defaultLabel={t('claims.notFound.goBack')}
      />
    );
  }
  return data ? <SettleContent claims={[data]} /> : <Spinner />;
};
